import React, { useState } from "react";
import { useIntl, FormattedMessage } from "react-intl";
import { get as _get, map as _map } from "lodash";
import { useDispatch } from "react-redux";

import { CustomModal } from "../../formElements/CustomModal";
import { showAlertMessage } from "../../formElements";

import { updateLoadingState } from "../../../../redux/actions/application";
import { saveSearch } from "../../../../redux/services/dataSearch";

const SaveSearchModal = ({
  selectedJobSeniority = [],
  selectedIndustry = [],
  selectedRegionCountry = [],
  selectedCompanySize = [],
  selectedRevenue = [],
  selectedDepartment = [],
  uploadedTalContactIds = [],
  defaultSearchDataPayload = {},
  fileUploaded = false,
  uploadedFileName = "",
  uploadedFileURL = "",
  onSuccess = () => { },
  savedSearchId = null,
  selectedIds = []
}) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const [searchName, setSearchName] = useState("");
  const [error, setError] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const validateAndShowModal = () => {
    if (savedSearchId) {
      showAlertMessage(
        intl.formatMessage({
          id: "data_search.save_search.error_search_already_saved",
          defaultMessage: "Search already saved for applied filters. Please change filters to save search with new name."
        })
      );
      return;
    }

    const hasAnyFilter = [
      selectedIds,
      selectedJobSeniority,
      selectedIndustry,
      selectedRegionCountry,
      selectedCompanySize,
      selectedRevenue,
      selectedDepartment,
      uploadedTalContactIds,
    ].some((arr) => (arr || []).length > 0);

    if (!hasAnyFilter) {
      showAlertMessage(
        intl.formatMessage({
          id: "error.select_atleast_one_filter",
          defaultMessage: "Please select at least one filter."
        })
      );
      return;
    }

    setIsModalOpen(true);
    setSearchName("");
    setError("");
  };

  const handleSubmit = async () => {
    if ((searchName || "").trim() === "") {
      setError(intl.formatMessage(
        { id: "error.required", defaultMessage: "{field} is required." },
        { field: intl.formatMessage({ id: "data_search.save_search.name", defaultMessage: "search name." }) }
      ));
      return;
    }

    try {
      if (typeof updateLoadingState === "function") { dispatch(updateLoadingState(true)); }

      const payload = {
        search_name: searchName.trim(),
        job_title_contact_ids: [],
        job_seniority: _map(selectedJobSeniority, (item) => _get(item, "id", "")),
        country: _map(selectedRegionCountry, (item) => _get(item, "id", "")),
        company_size: _map(selectedCompanySize, (item) => _get(item, "id", "")),
        revenue: _map(selectedRevenue, (item) => _get(item, "id", "")),
        department: _map(selectedDepartment, (item) => _get(item, "id", "")),
        industry: _map(selectedIndustry, (item) => _get(item, "id", "")),
        tal_contact_ids: uploadedTalContactIds,
        search_filter_json: JSON.stringify({
          selectedJobSeniority,
          selectedIndustry,
          selectedRegionCountry,
          selectedCompanySize,
          selectedRevenue,
          selectedDepartment,
          uploadedTalContactIds,
          defaultSearchDataPayload,
          fileUploaded,
          uploadedFileName,
          uploadedFileURL
        })
      };

      const response = await saveSearch(payload);

      if ((_get(response, "flag", false) === true)) {
        const savedSearchId = _get(response, "data.save_search_id", null);
        onSuccess(savedSearchId);
        showAlertMessage(_get(response, "data.message", "Search saved successfully."), "success");
        handleClose();
      } else {
        showAlertMessage(_get(response, "message", "Something went wrong while saving search."));
      }
    } catch (err) {
      showAlertMessage(_get(err, "message", "Something went wrong while saving search."));
    } finally {
      if (typeof updateLoadingState === "function") { dispatch(updateLoadingState(false)); }
    }
  };

  const handleClose = () => {
    setIsModalOpen(false);
    setSearchName("");
    setError("");
  };

  return (
    <>
      <button
        type="button"
        className="btn btn-outline-primary waves-effect flex-fill text-capitalize"
        onClick={validateAndShowModal}
      >
        <FormattedMessage id="btn.save_search" defaultMessage="save search" />
      </button>

      <CustomModal
        baseClassName="SaveSearchModal"
        isOpen={isModalOpen}
        onClose={handleClose}
        modalTitle={intl.formatMessage({ id: "data_search.save_search.title", defaultMessage: "Save Search" })}
        showCloseButton={true}
      >
        <div className="row g-3">
          <div className="col-12 pb-12">
            <label className="form-label text-capitalize">
              <FormattedMessage id="data_search.save_search.name" defaultMessage="Search Name" />
              <span className="text-danger">*</span>
            </label>
            <input
              type="text"
              className="form-control"
              value={searchName}
              onChange={(e) => { setSearchName(e.target.value); setError(""); }}
              placeholder={intl.formatMessage(
                { id: "placeholder.please_enter_field", defaultMessage: "Please enter {field}" },
                { field: intl.formatMessage({ id: "data_search.save_search.name", defaultMessage: "search name." }) }
              )}
            />
            {error && (<div className="invalid-feedback d-block">{error}</div>)}
          </div>
          <div className="col-12 d-flex justify-content-end gap-2 mt-2">
            <button type="button" className="btn btn-primary" onClick={handleSubmit}>
              <FormattedMessage id="btn.submit" defaultMessage="submit" />
            </button>
            <button type="button" className="btn btn-dark" onClick={handleClose}>
              <FormattedMessage id="btn.cancel" defaultMessage="cancel" />
            </button>
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default SaveSearchModal;
